export enum TypeEnum {
  String = "string",
  Boolean  = "boolean",
}